"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _web3Utils = require("web3-utils");

var _ethEnsNamehash = require("eth-ens-namehash");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var ENSRegistryContract = require('./contracts/ENSRegistry.js');

var SubdomainRegistrarContract = require('./contracts/SubdomainRegistrar.js');

var PublicResolverContract = require('./contracts/PublicResolver.js');

var KEY_STRING = '00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

class FDSENS2 {
  constructor(account, config) {
    this.account = account;
    this.config = config;
    this.ENSRegistry = new ENSRegistryContract(this.account, config.registryAddress);
    this.SubdomainRegistrar = new SubdomainRegistrarContract(this.account, config.subdomainRegistrarAddress);
    this.PublicResolver = new PublicResolverContract(this.account, config.resolverContractAddress);
  }

  registerSubdomain(subdomain) {
    var confirm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return this.SubdomainRegistrar.register((0, _web3Utils.sha3)(subdomain), '0x' + this.account.wallet.address, confirm);
  }

  setResolver(subdomain) {
    var confirm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var node = (0, _ethEnsNamehash.hash)(subdomain + '.' + this.config.domain);
    var addr = this.config.resolverContractAddress;
    return this.ENSRegistry.setResolver(node, addr, confirm);
  }

  setAll(subdomain, content, multihash, name) {
    var confirm = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var node = (0, _ethEnsNamehash.hash)(subdomain + '.' + this.config.domain);
    var publicKey = this.account.publicKey;
    var publicKeyX = publicKey.substring(0, 66);
    var publicKeyY = '0x' + publicKey.substring(66, 130);
    return this.PublicResolver.setAll(node, '0x' + this.account.wallet.address, content, multihash, publicKeyX, publicKeyY, name, confirm);
  }

  getAll(subdomain) {
    var confirm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var node = (0, _ethEnsNamehash.hash)(subdomain + '.' + this.config.domain);
    return this.PublicResolver.getAll(node, confirm);
  }

  setAddr(subdomain) {
    var confirm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var node = (0, _ethEnsNamehash.hash)(subdomain + '.' + this.config.domain); // not needed
    // let addr = this.config.resolverContractAddress;

    return this.PublicResolver.setAddr(node, this.account.wallet.address, confirm);
  }

  setPubkey(subdomain) {
    var confirm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var node = (0, _ethEnsNamehash.hash)(subdomain + '.' + this.config.domain);
    var publicKey = this.account.publicKey;
    var publicKeyX = publicKey.substring(0, 66);
    var publicKeyY = '0x' + publicKey.substring(66, 130);
    return this.PublicResolver.setPubkey(node, publicKeyX, publicKeyY, confirm);
  }

  setMultihash(subdomain, multihash) {
    var confirm = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var node = (0, _ethEnsNamehash.hash)(subdomain + '.' + this.config.domain);
    return this.PublicResolver.setMultihash(node, multihash, confirm);
  }
  /**
   * Get public key of subdoman
   * @param {string} subdomain name
   * @returns {string | boolean} returns false if invalid
   */


  getPubKey(subdomain) {
    var _this = this;

    return _asyncToGenerator(function* () {
      var node = (0, _ethEnsNamehash.hash)(subdomain + '.' + _this.config.domain);
      return _this.getPubKeyRaw(node);
    })();
  }
  /**
   * Get owner's address of subdoman
   * @param {string} subdomain name
   * @returns {string | boolean} returns false if invalid
   */


  getOwner(subdomain) {
    var _this2 = this;

    return _asyncToGenerator(function* () {
      var node = (0, _ethEnsNamehash.hash)(subdomain + '.' + _this2.config.domain);
      return _this2.ENSRegistry.owner(node);
    })();
  }
  /**
   * Get public key of subdoman
   * @param {string} subdomain name
   * @returns {string | boolean} returns false if invalid
   */


  getPubKeyRaw(node) {
    var _this3 = this;

    return _asyncToGenerator(function* () {
      var keyCoords = yield _this3.PublicResolver.getPubkey(node);
      var keyStr = '04' + keyCoords[0].substring(2, 66) + keyCoords[1].substring(2, 66);

      if (keyStr !== KEY_STRING) {
        return keyStr;
      } else {
        return false;
      }

      return keyStr;
    })();
  }
  /**
   * Get multihash of subdomain
   * @param {string} subdomain name
   * @returns {TransactionObject} transaction object
   */


  getMultihash(subdomain) {
    var node = (0, _ethEnsNamehash.hash)(subdomain + '.' + this.config.domain);
    return this.PublicResolver.getMultihash(node);
  }

}

var _default = FDSENS2;
exports.default = _default;
module.exports = exports.default;